import pageLoadingActionTypes from '../actionTypes/pageLoadingActionTypes';

const reducer = (state = false, { type, payload }) => {
  if (type === pageLoadingActionTypes.SET_IS_PAGE_LOADING) {
    return payload;
  }
  return state;
};

export default reducer;
